import cn from 'clsx';
import { HTMLAttributes } from 'react';

interface ChipProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  isSelected?: boolean;
}

export const Chip = ({ label, isSelected, className, ...props }: ChipProps) => {
  return (
    <div
      {...props}
      className={cn(
        'label-small-medium inline-flex items-center justify-center gap-[10px] rounded-full px-normal-small py-tiny-large hover:cursor-pointer select-none',
        {
          'border-[1px] border-neutral-background-inverse-low bg-neutral-background-inverse-low text-neutral-foreground-inverse-main': isSelected,
          'border-[1px] border-neutral-border-high bg-neutral-background-main text-neutral-foreground-lowest': !isSelected
        },
        className
      )}
    >
      {label}
    </div>
  );
};
